import { render, staticRenderFns } from "./MessagePlusOutline.vue?vue&type=template&id=6df67d43"
import script from "./MessagePlusOutline.vue?vue&type=script&lang=js"
export * from "./MessagePlusOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports